import React, { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { Description } from './Description';
import { Allowed } from './Allowed';
import { PoolDetailsPanel } from './PoolDetailsPanel';

import { ContentListType } from '@/pages/Pool';
import { Loader, Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui';
import { useAgreementData } from '@/pages/Pool/useAgreementData';

export const PoolDetailsTabs: React.FC = () => {
    const { address } = useParams<{ address: string }>();
    const [searchParams] = useSearchParams();
    const role = searchParams.get('role');

    const { agreements } = useAgreementData(role!);

    const agreement = useMemo(
        () =>
            agreements?.find(
                (item) =>
                    item.address.toLowerCase() === address?.toLowerCase() && item.role === role,
            ),
        [agreements, role],
    );

    if (!agreement) {
        return <Loader />;
    }

    return (
        <Tabs defaultValue={ContentListType.DESCRIPTION} className='w-[100%]'>
            <TabsList className='w-[100%] pl-[10%] border-b-2 border-gray-200 justify-normal'>
                <TabsTrigger
                    className='max-w-[200px]'
                    value={ContentListType.DESCRIPTION}
                    data-testid='pool-details-description'
                >
                    Description
                </TabsTrigger>
                <TabsTrigger
                    className='max-w-[200px]'
                    value={ContentListType.ALLOWED}
                    data-testid='pool-details-allowed'
                >
                    Allowed Tokens
                </TabsTrigger>
            </TabsList>
            <TabsContent value={ContentListType.DESCRIPTION}>
                <div className='flex justify-between px-[10%] py-9'>
                    <Description description={agreement.description || ''} />
                    <PoolDetailsPanel agreement={agreement} />
                </div>
            </TabsContent>
            <TabsContent value={ContentListType.ALLOWED}>
                <div className='flex justify-between px-[10%] py-9'>
                    <Allowed tokens={agreement.stressTestMatrix} />
                    <PoolDetailsPanel agreement={agreement} />
                </div>
            </TabsContent>
        </Tabs>
    );
};
